import React from 'react'
import List from './list'
import CreateBulk from './create-bulk'
import Stack from '@mui/material/Stack'
import VendorPicker  from '../../components/vendorPicker'
const publicityCampaigns = () => {
  return (
    <Stack
      direction="column"
      justifyContent="space-evenly"
      alignItems="center"
      spacing={2}
    >
      <VendorPicker/>
      <CreateBulk/>
      <List/>
    </Stack>
  )
}

export default publicityCampaigns;